<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:save="saveHandler"
        v-on:new="newHandler"
        v-on:delete="isConfirm = !isConfirm"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Form from "../../../components/attendance/clockdata/Form";
import ErrorDialogue from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import moment from "moment";

export default {
  components: {
    "app-form": Form,
    "app-error": ErrorDialogue,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      pageTitle: this.$t('clockdata.editclockdata'),
      pageTitleValue: "",
      formData: {
        id: null,
        staffid: null,
        staffcode: null,
        psnname: null,
        clockdate: null,
        clocktime: null,
        indicator: null,
        device: null,
        devicecode: null,
        devicedesc: null,
        reason: null,
        reasoncode: null,
        reasondesc: null,
        datesource: null,
        uploadedtime: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },
      cur_stamp: 0,
      errMsg: "",
      isErr: false,
      isConfirm: false,
      editMode: true,
      loading: true,
      search: this.$route.params.search,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    //insert new record
    saveHandler() {
      const vm = this;

      vm.formData.id = vm.id;
      vm.formData.stamp = vm.cur_stamp;
      console.log(vm.formData);
      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }
      this.$store.dispatch('put', {url: "/clockdata/" + vm.id,
          payload: vm.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "clockdatalist", params: { search: this.search}  });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
    loadClockData() {
      const vm = this;
      vm.loading = true;
      return this.$store.dispatch('get', {url: "/clockdata/" + vm.id})
        .then((res) => {
          console.log(res.data.rec);
          vm.formData.id = res.data.rec[0].id;
          vm.formData.staffid = res.data.rec[0].staffid;
          vm.formData.staffcode = res.data.rec[0].staffcode;
          vm.formData.psnname = res.data.rec[0].psnname;
          vm.formData.clockdate = moment(res.data.rec[0].clockdate).format("YYYY-MM-DD");
          vm.formData.clocktime = res.data.rec[0].clocktime;
          vm.formData.indicator = res.data.rec[0].indicator;
          vm.formData.device = res.data.rec[0].device;
          vm.formData.devicecode = res.data.rec[0].devicecode;
          vm.formData.devicedesc = res.data.rec[0].devicedesc;
          vm.formData.reason = res.data.rec[0].reason;
          vm.formData.reasoncode = res.data.rec[0].reasoncode;
          vm.formData.reasondesc = res.data.rec[0].reasondesc;
          vm.formData.datesource = res.data.rec[0].datesource;
          vm.formData.uploadedtime = res.data.rec[0].uploadedtime ? moment(res.data.rec[0].uploadedtime).format("YYYY-MM-DD HH:mm:ss") : null;
          vm.formData.stamp = res.data.rec[0].stamp;
          vm.cur_stamp = res.data.rec[0].stamp;

          vm.loading = false;
          console.log(vm.formData);
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },

    cancelHandler() {
      this.$router.push({ name: "clockdatalist" });
    },

    newHandler() {
      this.$router.push({ name: "clockdatanew" });
    },

    deleteHandler() {
      const vm = this;
      if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
        return false;
      }
      this.$store.dispatch('delete', {url: "/clockdata/" + vm.id})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "clockdatalist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },
  async mounted() {
    this.loadClockData();
  },
};
</script>